import { AnalitycsEvent } from '../models/analytics-event.model';
import { CitydealsEvent } from '../models/citydeals-event.model';
import { EventProduct } from '../models/event-product.model';

export class RemoveFromCartEvent implements CitydealsEvent {
  static eventName = 'removeFromCart';
  private product: EventProduct;

  constructor(product: EventProduct) {
    this.product = product;
  }

  getEvent(): AnalitycsEvent {
    return {
      event: RemoveFromCartEvent.eventName,
      ecommerce: {
        currencyCode: 'HUF',
        remove: {
          products: [this.product],
        },
      },
    };
  }
}
